import { type FC, type PropsWithChildren, createContext, useState } from 'react';
import { type IUser } from '../types/user';

// NOTA: el theme claro/oscuro vive únicamente en `ThemeContext`.
// Antes existía un segundo estado de tema aquí, sin usar, que podía
// desincronizarse del real; se eliminó para tener una única fuente de verdad.

interface IAuthContext {
  user: IUser | null
  setUser: (user: IUser | null) => void
}

export const AuthContext = createContext<IAuthContext>({
  user: null,
  setUser: () => {}
});

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const [user, setUser] = useState<IUser | null>(null);

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>

  );
};
